import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Profile from './Profile';
import { useAuth } from '../../../context/AuthContext';
import Orders from './Orders';
// import Subscriptions from './Subscriptions';
import SiteNavBar from '../navigation/SiteNavBar';

const tabs = [
  { key: 'profile', label: 'Profile' },
  // { key: 'subscriptions', label: 'Subscriptions' },
  { key: 'orders', label: 'Orders' },
  { key: 'logout', label: 'Logout' }
];

const AccountDashboard = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { logout } = useAuth();
  const params = new URLSearchParams(search);
  const requestedTab = params.get('tab');
  const allowedTabs = tabs.map((t) => t.key);
  const tab = allowedTabs.includes(requestedTab) ? requestedTab : 'profile';

  const handleTabClick = (key) => {
    if (key === 'logout') {
      if (!window.confirm('Are you sure you want to log out?')) {
        return;
      }
      logout();
      navigate('/account/signin');
    } else {
      navigate(`/account/dashboard?tab=${key}`);
    }
  };

  return (
    <div>
      <SiteNavBar />
      <div style={{ display: 'flex', minHeight: '80vh', background: '#f9f9f9' }}>
        {/* Sidebar */}
        <div style={{ width: 220, background: '#fff', borderRight: '1px solid #eee', padding: 24 }}>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {tabs.map(t => (
              <li
                key={t.key}
                onClick={() => handleTabClick(t.key)}
                style={{
                  padding: '12px 0',
                  cursor: 'pointer',
                  color: tab === t.key ? '#F28123' : '#333',
                  fontWeight: tab === t.key ? 'bold' : 'normal'
                }}
              >{t.label}</li>
            ))}
          </ul>
        </div>
        {/* Main Content */}
        <div style={{ flex: 1, padding: 32 }}>
          {tab === 'profile' && <Profile />}
          {/* {tab === 'subscriptions' && <Subscriptions />} */}
          {tab === 'orders' && <Orders />}
          {/* Logout handled above */}
        </div>
      </div>
    </div>
  );
};

export default AccountDashboard; 